import {CustomUserField} from "@/features/management-v2/custom-user-fields/types";
import {useCallback, useState} from "react";
import {apiV2} from "@/api/axiosConfig";
import axios from "axios";

type UseSubmitCustomUserFieldsReturn = {
    submitFields: (fields: CustomUserField[]) => Promise<void>
    loading: boolean
    error: string | null
    success: boolean
}

export function useSubmitCustomUserFields(clientID?: string): UseSubmitCustomUserFieldsReturn {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState(false)

    const submitFields = useCallback(async (fields: CustomUserField[]) => {
        setLoading(true)
        setError(null)
        setSuccess(false)

        try {
            const url = clientID
                ? `/custom-user-fields/${clientID}`
                : "/custom-user-fields"

            await apiV2.post(url, fields, {
                headers: {
                    "Content-Type": "application/json"
                }
            })

            setSuccess(true)
        } catch (err) {
            const message = axios.isAxiosError(err)
                ? (err.response?.data?.error ?? "Failed to save custom fields")
                : "Failed to save custom fields"
            setError(message)
            setSuccess(false)
        } finally {
            setLoading(false)
        }
    }, [clientID])

    return {
        submitFields,
        loading,
        error,
        success
    }
}